<template>
  <div class="flex h-full w-full flex-col">
    <div class="flex flex-1 flex-col items-center justify-center gap-4 text-center">
      <img
        src="/auth/advisor-badge.svg"
        alt=""
        aria-hidden="true"
        class="h-40 w-40"
      >
      <div class="font-display">
        <h1 class="text-lg font-semibold text-primal">
          We have received your request
        </h1>
        <p class="mt-1 text-sm text-secondary">
          You will soon receive an email with the steps needed to setup your advisor account on Forgd.
        </p>
      </div>
    </div>
  </div>
</template>
